import { observer } from "mobx-react-lite";
import * as S from "../style";
import { Button, Icon, Text } from "@smartsuite/react-ui/lib";
import type { OutputData } from "@smartsuite/automation-engine-api";
import { translateIfPresent } from "../../../../../../locales/i18n";
import { StringEditor } from "../../../../Forms/InputForm/FieldEditor/FieldEditorRow/fields/StringEditor";
import type {
  InputCandidate,
  TriggerCandidate,
} from "../../../../../../types/candidate";
import { StatusBadge } from "../elements/status-badge";
import { useTranslation } from "react-i18next";
import { TextColorNames } from "@smartsuite/types";

export const OutputDetails = observer<{
  outputs: OutputData[];
  trigger: TriggerCandidate;
  onSend: () => void;
  onChange: (output: OutputData) => void;
  error?: string;
  loading: boolean;
}>(({ outputs, onSend, onChange, error, loading, trigger }) => {
  const { t } = useTranslation();
  const onItemChange = (input: InputCandidate): void => {
    const output = outputs.find((output) => output.outputId === input.inputId);
    if (output && input.value) {
      onChange({
        ...output,
        value: {
          values: input.value.values.map((v) => ({
            icon: "",
            label: "",
            value: {
              oneofKind: "string",
              string: v.value.oneofKind === "string" ? v.value.string : "",
            },
          })),
          metadata: {},
        },
      });
    }
  };
  return (
    <S.Wrapper>
      <S.Title>{t("automation.action-test-output-description")}</S.Title>
      {error && <StatusBadge status={"error"} title={error} />}
      <S.ItemWrapper>
        {outputs.map((output) => (
          <S.Item key={output.outputId}>
            {output.icon && (
              <S.IconWrapper top={"unset"}>
                <Icon
                  name={output.icon}
                  size="S"
                  color={TextColorNames.tertiary}
                />
              </S.IconWrapper>
            )}
            <S.LabelWrapper>
              <Text size="l">{output.outputLabel}</Text>
            </S.LabelWrapper>
            <StringEditor
              input={{
                inputId: output.outputId,
                value: {
                  values:
                    output.value?.values.map((v) => ({
                      value: {
                        oneofKind: "string",
                        string:
                          v.value.oneofKind === "string" ? v.value.string : "",
                      },
                    })) ?? [],
                },
              }}
              onChange={onItemChange}
              trigger={trigger}
              actions={[]}
              integrations={[]}
              isMultiple={false}
              showValidationError={false}
              disableReferences={true}
              placeholder={""}
            />
          </S.Item>
        ))}
      </S.ItemWrapper>
      <S.Hr />
      <S.ButtonWrapper>
        <Button onClick={onSend} loading={loading} disabled={loading}>
          {translateIfPresent("automation.action-test-run", "Run Test")}
        </Button>
      </S.ButtonWrapper>
    </S.Wrapper>
  );
});
